import classnames from 'classnames/bind';
import { useTranslation, Trans } from 'react-i18next';
import { Icon, IconSize } from 'app/components/core/Icon';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function ChangeWarehouseCard({ count, isActive, onClick }) {
    const { t } = useTranslation('components', {
        keyPrefix: 'WarehouseLoadDialog.warehouses'
    });
    const warehouses = Math.max(0, count - 1);

    return (
        <button className={cx('action-card')} onClick={onClick} aria-pressed={isActive}>
            <Icon className={cx('icon')} variant="warehouse" size={IconSize.LARGE} />
            <p className={cx('description')}>
                <Trans
                    t={t}
                    i18nKey="description"
                    components={{ b: <strong /> }}
                    values={{ warehouses }}
                />
            </p>
            <p className={cx('hint')}>{t('hint')}</p>
            <div className={cx('cta')}>{t('cta')}</div>
        </button>
    );
}
